<template>
<div 
  v-bind:class="[ showLabel ? 'col-lg-'+lg*col : '',showLabel ? 'col-md-'+md*col : '',showLabel ? 'col-sm-'+sm*col : '', {'align-self-center' : datadb[inputTabla][inputCampo].datatype.type==='check'} ]"
  v-if="( minform && datadb[inputTabla][inputCampo].datatype.minform) || ( minform===false && datadb[inputTabla][inputCampo].namepath.includes(namePath))" style="padding: 0 10px"
  class="sw-inputs">    
  <div     
    v-if="showLabel"
    >
  <!--MUESTRA EL LABEL-->   
    <validation-provider 
        :rules="datadb[inputTabla][inputCampo].validate" immediate  
        v-slot="{ errors, required }"
        :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" 
        style="position:relative" 
        v-if="datadb[inputTabla][inputCampo].datatype.type==='check'"> 
      <b-form-checkbox
            style="font-size:17px"
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            size="lg"
            :value="1"
            :unchecked-value="0"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            @change="changeInput"
            @input="inputInput"
          >
          {{datadb[inputTabla][inputCampo].label}}
      </b-form-checkbox>
    </validation-provider>
    <b-form-group v-if="datadb[inputTabla][inputCampo].datatype.type!=='check' && inline===false"
        :label="datadb[inputTabla][inputCampo].label"
      >
    <!-- LABEL TOP -->     
      <b-icon v-b-toggle.sidebar-configuracion @click="sidebar=inputTabla+inputCampo" icon="gear" class="input-config" v-if="datadb[inputTabla][inputCampo].datatype.type!=='file'" tabindex="1000"></b-icon> 

      <validation-provider  v-if="datadb[inputTabla][inputCampo].datatype.type==='radio'" :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors, required }"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" style="position:relative"> 
        <b-form-radio-group
          id="radio-group-1"
          v-model="dataForm[namePath][inputTabla][inputCampo]"
          :options="datadb[inputTabla][inputCampo].datatype.options"
          name="radio-options"
        ></b-form-radio-group>
          <small  class="text-danger input-errors">{{errors[0]}}</small>
      </validation-provider>
      <b-input-group  v-if="datadb[inputTabla][inputCampo].datatype.type==='input'">
        <validation-provider :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors, required }"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" style="position:relative"> 
          <b-form-input
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])}"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
            size="sm"
            :trim="true"
            :type="datadb[inputTabla][inputCampo].type"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
            >
          </b-form-input>
          <small  class="text-danger input-errors">{{errors[0]}}</small>
        </validation-provider>
        <b-list-group class="sw-list-group" v-if="searchs.length>0 && includeDatalist(list,dataForm[namePath][inputTabla][inputCampo],inputCampo).length>0 && activeInput">
          <b-list-group-item style="padding: 5px 10px;font-weight:500;font-size:15px">Lista de coincidencias <b-icon tabindex="1000" @click="activeInput=false" icon="x" style=" cursor:pointer; font-size: 22px !important; position: absolute; right: 10px;"></b-icon></b-list-group-item>
          <b-list-group-item @click="eventBuscar(items.id)" button v-for="(items,index) in includeDatalist(list,dataForm[namePath][inputTabla][inputCampo],inputCampo)" :key="'filterDataLis'+index" >
            <span v-for="(items2,index2) in searchs" :key="index+'searchs'+index2">
              <span v-if="items2.includes('id_list_') || items2.includes('id_datos_')">{{gettersDatalist(items2.substring(3),items[items2])[0].name}} </span>
              <span v-else>{{items[items2]}} </span>              
            </span>
            </b-list-group-item>
        </b-list-group>
      </b-input-group>  

      <b-input-group  v-if="datadb[inputTabla][inputCampo].datatype.type==='email'">
        <validation-provider :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors, required }"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" style="position:relative"> 
          <b-form-input
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])}"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
            size="sm"
            :trim="true"
            :type="datadb[inputTabla][inputCampo].type"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
            >
          </b-form-input>
          <small  class="text-danger input-errors">{{errors[0]}}</small>
        </validation-provider>
      </b-input-group>

      <b-input-group  v-if="datadb[inputTabla][inputCampo].datatype.type==='price'"
        :prepend="datadb[inputTabla][inputCampo].datatype.prepend" 
        :append="datadb[inputTabla][inputCampo].datatype.append"
        size="sm">   
        <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }" style="position:relative">     
          <vue-numeric 
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"
            separator="."   
            class="form-control"   
            :empty-value="datadb[inputTabla][inputCampo].datatype.predeterminate"        
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :precision="datadb[inputTabla][inputCampo].datatype.precision"
            :read-only="datadb[inputTabla][inputCampo].datatype.readonly"
            :read-only-class="datadb[inputTabla][inputCampo].datatype.readonlyclass"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            @input="inputInput();updateActiveInput(dataForm[namePath][inputTabla][inputCampo])"
            @blur="blurInput;">
          </vue-numeric>  
          <small class="text-danger input-errors">{{errors[0]}}</small>
        </validation-provider> 
        <b-list-group class="sw-list-group" v-if="searchs.length>0 && includeDatalist(list,dataForm[namePath][inputTabla][inputCampo],inputCampo).length>0 && activeInput">
          <b-list-group-item style="padding: 5px 10px;font-weight:500;font-size:15px">Lista de coincidencias <b-icon tabindex="1000" @click="activeInput=false" icon="x" style=" cursor:pointer; font-size: 22px !important; position: absolute; right: 10px;"></b-icon></b-list-group-item>
          <b-list-group-item @click="eventBuscar(items.id)" button v-for="(items,index) in includeDatalist(list,dataForm[namePath][inputTabla][inputCampo],inputCampo)" :key="'filterDataLis'+index" >
            <span v-for="(items2,index2) in searchs" :key="index+'searchs'+index2">
              <span v-if="items2.includes('id_list_') || items2.includes('id_datos_')">{{gettersDatalist(items2.substring(3),items[items2])[0].name}} </span>
              <span v-else>{{items[items2]}} </span>              
            </span>
            </b-list-group-item>
        </b-list-group>
      </b-input-group>
      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"  v-if="datadb[inputTabla][inputCampo] .datatype.type==='textarea'" style="position:relative">  
          <b-form-textarea 
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
            :trim="true"            
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :no-resize="datadb[inputTabla][inputCampo].datatype.noresize"
            :rows="datadb[inputTabla][inputCampo].datatype.rows"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
          ></b-form-textarea>  
          <small  class="text-danger textarea-errors">{{errors[0]}}</small>
      </validation-provider>  
      
      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"           v-if="datadb[inputTabla][inputCampo].datatype.type==='file'" style="position:relative">  
               
          <editor
            v-if="data.loaded"
            ref="editor"
            :data="data"
            :tabla="inputTabla"
            :campo="inputCampo"
          />
          <loader
            ref="loader"
            :data="data"
            :tabla="inputTabla"
            :campo="inputCampo"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
          />     
        <small  class="text-danger file-errors">{{errors[0]}}</small>
      </validation-provider>  
       
      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"             
        v-if="datadb[inputTabla][inputCampo].datatype.type==='date'" style="position:relative">  
        <input 
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"            
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            class="input-date" 
            type="date"  
            v-model="dataForm[namePath][inputTabla][inputCampo]" 
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput">      
        <small  class="text-danger file-errors">{{errors[0]}}</small>
      </validation-provider>

      <b-input-group  v-if="datadb[inputTabla][inputCampo].datatype.type==='ftn'"         
        >
        <validation-provider :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors,required }"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" style="position:relative"> 
          <b-form-input
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])}"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
            size="sm"
            :trim="true"
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :type="datadb[inputTabla][inputCampo].type"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            @change="changeInput(datadb[inputTabla][inputCampo].id)"
            @input="inputInput(datadb[inputTabla][inputCampo].id)"
            @update="updateInput(datadb[inputTabla][inputCampo].id)"
            @blur="blurInput(datadb[inputTabla][inputCampo].id)"
            >
          </b-form-input>
          <small  class="text-danger input-errors">{{errors[0]}}</small>
        </validation-provider>
      </b-input-group>    

      <validation-provider  
        v-if="datadb[inputTabla][inputCampo].datatype.type==='select'  && datadb[inputTabla][inputCampo].datatype.multiple===undefined" immediate 
        :rules="datadb[inputTabla][inputCampo].validate" 
        v-slot="{ errors }" 
        style="position:relative">    
        <c-multiselect  
          v-bind:class="{'is-invalid': veevalidateSelect(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"
          :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :placeholder="datadb[inputTabla][inputCampo].placeholder"
          v-model="dataForm[namePath][inputTabla][inputCampo]"
          :options="filtrarOptions()"
          :label="datadb[inputTabla][inputCampo].datatype.label"
          :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
          :allow-empty="false"
          @input="InputSelect($event,datadb[inputTabla][inputCampo].id);"
          @select="SelectSelect($event,datadb[inputTabla][inputCampo].id)"
          @remove="removeSelect($event,datadb[inputTabla][inputCampo].id)"
          @search-change="searchChangeSelect($event,datadb[inputTabla][inputCampo].id)"
          @tag="tagSelect($event,datadb[inputTabla][inputCampo].id)"
          @open="openSelect($event,datadb[inputTabla][inputCampo].id)"
          @close="closeSelect($event,datadb[inputTabla][inputCampo].id)">	
          <template v-slot:afterList  v-if="agregarSw">
            <div class="text-center" style="border-top: 1px solid #dcdcdc">
              <button type="button" @click="agregar" class="btn btn-link btn-sm">Agregar <b-icon tabindex="1000" scale="1.4" icon="plus"></b-icon></button>
            </div>            
          </template>									 
        </c-multiselect> 
        <small class="text-danger select-errors">{{errors[0]}}</small>
      </validation-provider> 

      <validation-provider  
        v-if="datadb[inputTabla][inputCampo].datatype.type==='select'  && datadb[inputTabla][inputCampo].datatype.multiple" immediate 
        :rules="datadb[inputTabla][inputCampo].validate" 
        v-slot="{ errors }" 
        style="position:relative">    
        <c-multiselects  
          v-bind:class="{'is-invalid': veevalidateSelect(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"
          :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :placeholder="datadb[inputTabla][inputCampo].placeholder"
          v-model="dataForm[namePath][inputTabla][inputCampo]"
          :options="filtrarOptions()"
          track-by="name"
          :label="datadb[inputTabla][inputCampo].datatype.label"
          :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
          :multiple="true"
          :close-on-select="true"
          :clear-on-select="false"
          :preselect-first="false"
          :searchable="false"
        >	
          <template v-slot:afterList  v-if="agregarSw">
            <div class="text-center" style="border-top: 1px solid #dcdcdc">
              <button type="button" @click="agregar" class="btn btn-link btn-sm">Agregar <b-icon tabindex="1000" scale="1.4" icon="plus"></b-icon></button>
            </div>            
          </template>									 
        </c-multiselects> 
        <small class="text-danger select-errors">{{errors[0]}}</small>
      </validation-provider> 

       <validation-provider  
        v-if="datadb[inputTabla][inputCampo].datatype.type==='multiselect'" immediate 
        :rules="datadb[inputTabla][inputCampo].validate" 
        v-slot="{ errors }" 
        style="position:relative">    
        <c-multiselects  
          v-bind:class="{'is-invalid': veevalidateSelect(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"
          :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :placeholder="datadb[inputTabla][inputCampo].placeholder"
          v-model="dataForm[namePath][inputTabla][inputCampo]"
          :options="filtrarOptionsReferido()"
          :filterCampos="'name|documento'"
          track-by="name"
          :customLabel="function (value) { return value.documento+' - '+value.name}"
          :label="datadb[inputTabla][inputCampo].datatype.label"
          :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
          :close-on-select="true"
          :clear-on-select="false"
          :preselect-first="false"
        >	
          <template v-slot:noResult>
            Sin resultados.
          </template>
          <template v-slot:afterList  v-if="agregarSw">
            <div class="text-center" style="border-top: 1px solid #dcdcdc">
              <button type="button" @click="agregar" class="btn btn-link btn-sm">Agregar <b-icon tabindex="1000" scale="1.4" icon="plus"></b-icon></button>
            </div>            
          </template>									 
        </c-multiselects> 
        <small class="text-danger select-errors">{{errors[0]}}</small>
      </validation-provider> 


    </b-form-group>  
    <div  v-if="datadb[inputTabla][inputCampo].datatype.type!=='check' && inline" style="margin-top:5px"> 
    <!-- LABEL INLINE -->         
      <b-icon tabindex="1000" v-b-toggle.sidebar-configuracion @click="sidebar=inputTabla+inputCampo" icon="gear" class="input-config-inline" v-if="datadb[inputTabla][inputCampo].datatype.type!=='file'"></b-icon>     
        <validation-provider :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors }"  v-if="datadb[inputTabla][inputCampo].datatype.type==='input'"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" style="position:relative"> 
          <b-input-group size="sm" :prepend="datadb[inputTabla][inputCampo].label">
            <b-form-input 
              class="text-capitalize"
              :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])}"
              :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
              size="sm"
              :trim="true"
              :type="datadb[inputTabla][inputCampo].type"
              :placeholder="datadb[inputTabla][inputCampo].placeholder"
              v-model="dataForm[namePath][inputTabla][inputCampo]"
              :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
              @change="changeInput"
              @input="inputInput();updateActiveInput(dataForm[namePath][inputTabla][inputCampo])"
              @blur="blurInput"            
            ></b-form-input>
            <b-list-group class="sw-list-group" v-if="searchs.length>0 && includeDatalist(list,dataForm[namePath][inputTabla][inputCampo],inputCampo).length>0 && activeInput">
              <b-list-group-item style="padding: 5px 10px;font-weight:500;font-size:15px">Lista de coincidencias <b-icon tabindex="1000" @click="activeInput=false" icon="x" style=" cursor:pointer; font-size: 22px !important; position: absolute; right: 10px;"></b-icon></b-list-group-item>
              <b-list-group-item @click="eventBuscar(items.id)" button v-for="(items,index) in includeDatalist(list,dataForm[namePath][inputTabla][inputCampo],inputCampo)" :key="'filterDataLis'+index" >
                <span v-for="(items2,index2) in searchs" :key="index+'searchs'+index2">
                  <span v-if="items2.includes('id_list_') || items2.includes('id_datos_')">{{gettersDatalist(items2.substring(3),items[items2])[0].name}} </span>
                  <span v-else>{{items[items2]}} </span>              
                </span>
                </b-list-group-item>
            </b-list-group>
          </b-input-group>
        </validation-provider>

        <validation-provider 
          :rules="datadb[inputTabla][inputCampo].validate" immediate  
          v-slot="{ errors }"  
          v-if="datadb[inputTabla][inputCampo].datatype.type==='email'"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" s
          tyle="position:relative"> 
          <b-input-group size="sm" :prepend="datadb[inputTabla][inputCampo].label">
            <b-form-input 
              class="text-lowercase"
              :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])}"
              :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
              size="sm"
              :trim="true"
              :type="datadb[inputTabla][inputCampo].type"
              :placeholder="datadb[inputTabla][inputCampo].placeholder"
              v-model="dataForm[namePath][inputTabla][inputCampo]"
              :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
              @change="changeInput"
              @input="inputInput"
              @blur="blurInput"            
            ></b-form-input>
          </b-input-group>
        </validation-provider>

        <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }" style="position:relative" v-if="datadb[inputTabla][inputCampo].datatype.type==='price'"> 
          <b-input-group size="sm" :prepend="datadb[inputTabla][inputCampo].label">    
            <vue-numeric 
              style="display:inline-block;flex: 1 1 0%"
              v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"
              separator="."   
              class="form-control" 
              :empty-value="datadb[inputTabla][inputCampo].datatype.predeterminate"          
              :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              v-model="dataForm[namePath][inputTabla][inputCampo]"
              :precision="datadb[inputTabla][inputCampo].datatype.precision"
              :read-only="datadb[inputTabla][inputCampo].datatype.readonly"
              :read-only-class="datadb[inputTabla][inputCampo].datatype.readonlyclass"
              :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
              @input="inputInput"
              @blur="blurInput" >
            </vue-numeric> 
          </b-input-group>
        </validation-provider>

        <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"           v-if="datadb[inputTabla][inputCampo].datatype.type==='file'" style="position:relative">                   
          <editor
            v-if="data.loaded"
            ref="editor"
            :data="data"
            :tabla="inputTabla"
            :campo="inputCampo"
          />
          <loader
            ref="loader"
            :data="data"
            :tabla="inputTabla"
            :campo="inputCampo"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
          />     
        </validation-provider>  

      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"             
        v-if="datadb[inputTabla][inputCampo].datatype.type==='date'" style="position:relative">  
        <b-input-group size="sm" :prepend="datadb[inputTabla][inputCampo].label"> 
          <input 
              style="display:inline-block;flex: 1 1 0%"
              v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"            
              :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
              class="input-date" 
              type="date"  
              v-model="dataForm[namePath][inputTabla][inputCampo]" 
              @change="changeInput"
              @input="inputInput"
              @blur="blurInput">  
        </b-input-group>    
      </validation-provider>
     
      <b-input-group size="sm" :prepend="datadb[inputTabla][inputCampo].label" v-if="datadb[inputTabla][inputCampo].datatype.type==='select'"> 
        <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"             
        >  
          <c-multiselect  
            style="display:inline-block; flex: 1 1 0%"
            v-bind:class="{'is-invalid': veevalidateSelect(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :options="filtrarOptions()"
            :label="datadb[inputTabla][inputCampo].datatype.label"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            :allow-empty="false"
            @input="InputSelect($event,datadb[inputTabla][inputCampo].id)"
            @select="SelectSelect($event,datadb[inputTabla][inputCampo].id)"
            @remove="removeSelect($event,datadb[inputTabla][inputCampo].id)"
            @search-change="searchChangeSelect($event,datadb[inputTabla][inputCampo].id)"
            @tag="tagSelect($event,datadb[inputTabla][inputCampo].id)"
            @open="openSelect($event,datadb[inputTabla][inputCampo].id)"
            @close="closeSelect($event,datadb[inputTabla][inputCampo].id)">	
            <template v-slot:afterList  v-if="agregarSw">
              <div class="text-center" style="border-top: 1px solid #dcdcdc">
                <button type="button" @click="agregar" class="btn btn-link btn-sm">Agregar <b-icon scale="1.4" icon="plus"></b-icon></button>
              </div>            
            </template>									 
          </c-multiselect> 
        </validation-provider>
      </b-input-group>
    </div>
  </div>
  <div v-if="(( minform && datadb[inputTabla][inputCampo].datatype.minform) || minform===false) &&  showLabel===false "> 
  <!-- NO MUESTRA EL LABEL -->
      <b-icon tabindex="1000" v-b-toggle.sidebar-configuracion @click="sidebar=inputTabla+inputCampo" icon="gear" class="input-config-nolabel" v-if="datadb[inputTabla][inputCampo].datatype.type!=='file'"></b-icon>          
      <validation-provider 
          :rules="datadb[inputTabla][inputCampo].validate" immediate  
          v-slot="{ errors, required }"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" 
          style="position:relative" 
          v-if="datadb[inputTabla][inputCampo].datatype.type==='check'"> 
        <b-form-checkbox
              :value="1"
              :unchecked-value="1"
              :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
              size="lg"
              v-model="dataForm[namePath][inputTabla][inputCampo]"
              :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
              @change="changeInput"
              @input="inputInput"
            >
        </b-form-checkbox>        
      </validation-provider>

      <validation-provider :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors, required }"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" style="position:relative"
             v-if="datadb[inputTabla][inputCampo].datatype.type==='input'"> 
          <b-form-input
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])}"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
            size="sm"
            :trim="true"
            :type="datadb[inputTabla][inputCampo].type"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
            >
          </b-form-input>
          <small  class="text-danger input-errors-table">{{errors[0]}}</small>
      </validation-provider>

      

      <validation-provider :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors, required }"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" style="position:relative"
             v-if="datadb[inputTabla][inputCampo].datatype.type==='email'"> 
          <b-form-input
            class="text-lowercase"
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])}"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
            size="sm"
            :trim="true"
            :type="datadb[inputTabla][inputCampo].type"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
            >
          </b-form-input>
          <small  class="text-danger input-errors-table">{{errors[0]}}</small>
      </validation-provider>

      <validation-provider  v-if="datadb[inputTabla][inputCampo].datatype.type==='price'" immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }" style="position:relative">     
        <vue-numeric 
          v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"
          separator="."   
          class="form-control" 
          :empty-value="datadb[inputTabla][inputCampo].datatype.predeterminate" 
          :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          v-model="dataForm[namePath][inputTabla][inputCampo]"
          :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
          :precision="datadb[inputTabla][inputCampo].datatype.precision"
          :read-only="datadb[inputTabla][inputCampo].datatype.readonly"
          :read-only-class="datadb[inputTabla][inputCampo].datatype.readonlyclass"
          @input="inputInput"
          @blur="blurInput" >
        </vue-numeric>   
          <small  class="text-danger input-errors-table">{{errors[0]}}</small>
      </validation-provider>   

      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"  v-if="datadb[inputTabla][inputCampo] .datatype.type==='textarea'" style="position:relative">  
          <b-form-textarea 
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
            :trim="true"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :placeholder="datadb[inputTabla][inputCampo].placeholder"
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :no-resize="datadb[inputTabla][inputCampo].datatype.noresize"
            :rows="datadb[inputTabla][inputCampo].datatype.rows"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
          ></b-form-textarea> 
          <small  class="text-danger input-errors-table">{{errors[0]}}</small> 
      </validation-provider>  
      
      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"          
       v-if="datadb[inputTabla][inputCampo].datatype.type==='file'" style="position:relative">          
          <editor
            v-if="data.loaded"
            ref="editor"
            :data="data"
            :tabla="inputTabla"
            :campo="inputCampo"
          />
          <loader
            ref="loader"
            :data="data"
            :tabla="inputTabla"
            :campo="inputCampo"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
          />       
          <small  class="text-danger input-errors-table">{{errors[0]}}</small>
      </validation-provider>  
       
      <validation-provider immediate :rules="datadb[inputTabla][inputCampo].validate" v-slot="{ errors }"             v-if="datadb[inputTabla][inputCampo].datatype.type==='date'" style="position:relative">  
        <input 
            v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"            
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
            class="input-date" 
            type="date"  
            v-model="dataForm[namePath][inputTabla][inputCampo]"
            :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"> 
          <small  class="text-danger input-errors-table">{{errors[0]}}</small>     
      </validation-provider>
 
      <validation-provider  v-if="datadb[inputTabla][inputCampo].datatype.type==='ftn'"   :rules="datadb[inputTabla][inputCampo].validate" immediate  v-slot="{ errors, required }"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]" style="position:relative"> 
        <b-form-input
          v-bind:class="{'is-invalid': veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])}"
          :state="veevalidateInputs(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])"
          size="sm"
          :trim="true"
          :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :type="datadb[inputTabla][inputCampo].type"
          :placeholder="datadb[inputTabla][inputCampo].placeholder"
          v-model="dataForm[namePath][inputTabla][inputCampo]"
          :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
          @change="changeInput(datadb[inputTabla][inputCampo].id)"
          @input="inputInput(datadb[inputTabla][inputCampo].id)"
          @update="updateInput(datadb[inputTabla][inputCampo].id)"
          @blur="blurInput(datadb[inputTabla][inputCampo].id)"
          >
        </b-form-input>
          <small  class="text-danger input-errors-table">{{errors[0]}}</small>
      </validation-provider>

      <validation-provider  
        v-if="datadb[inputTabla][inputCampo].datatype.type==='select'" immediate 
        :rules="datadb[inputTabla][inputCampo].validate" 
        v-slot="{ errors }" 
        style="position:relative"> 
        <c-multiselect  
          v-bind:class="{'is-invalid': veevalidateSelect(errors[0],datadb[inputTabla][inputCampo].validate,dataForm[namePath][inputTabla][inputCampo])===false}"
          :id="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :name="namePath+inputTabla+inputCampo+dataIndex[namePath]"
          :placeholder="datadb[inputTabla][inputCampo].placeholder"
          v-model="dataForm[namePath][inputTabla][inputCampo]"
          :disabled="datadb[inputTabla][inputCampo].datatype.disabled || disabledCampo || disabled"
          :options="filtrarOptions()"
          :label="datadb[inputTabla][inputCampo].datatype.label"
          :allow-empty="false"
          @input="InputSelect($event,datadb[inputTabla][inputCampo].id)"
          @select="SelectSelect($event,datadb[inputTabla][inputCampo].id)"
          @remove="removeSelect($event,datadb[inputTabla][inputCampo].id)"
          @search-change="searchChangeSelect($event,datadb[inputTabla][inputCampo].id)"
          @tag="tagSelect($event,datadb[inputTabla][inputCampo].id)"
          @open="openSelect($event,datadb[inputTabla][inputCampo].id)"
          @close="closeSelect($event,datadb[inputTabla][inputCampo].id)">
          <template v-slot:afterList v-if="agregarSw">
            <div class="text-center" style="border-top: 1px solid #dcdcdc">
              <button type="button" @click="agregar" class="btn btn-link btn-sm">Agregar <b-icon tabindex="1000" scale="1.4" icon="plus"></b-icon></button>
            </div>            
          </template>										 
        </c-multiselect> 
          <small  class="text-danger input-errors-table">{{errors[0]}}</small>
      </validation-provider> 
  </div>
  <b-modal 
    v-model="modalInput.value"
    :title="modalInput.title" 
    :header-bg-variant="modalInput.variant"
    header-text-variant="light"
    :hide-footer="true"  
    :no-close-on-backdrop="true" 
    :size="modalInput.size" 
    @hide="modalInput.value=false" 
    >
      <slot name="modal" v-bind:modalInput="modalInput"></slot>            
  </b-modal> 
  <b-sidebar
      v-if="sidebar===inputTabla+inputCampo"
      id="sidebar-configuracion"
      title="Configurar"
      backdrop
      @hidden="sidebar='';resetCrud({state: 'dataForm/configuracion'})"
      @shown="setPredeterminado"
      shadow
      no-close-on-backdrop
    >
      <div class="px-3 py-2" >
        <b-form-group   v-if="datadb[inputTabla][inputCampo].datatype.type!=='check' && datadb[inputTabla][inputCampo].datatype.type!=='date'"
            label="Predeterminar el valor"
          >   
          <b-form-input
              v-if="datadb[inputTabla][inputCampo].datatype.type=='input'"
              class="text-lowercase"
              :id="namePath+inputTabla+inputCampo+dataIndex[namePath]+'configurar'"
              :name="namePath+inputTabla+inputCampo+dataIndex[namePath]+'configurar'"
              size="sm"
              :trim="true"
              :type="datadb[inputTabla][inputCampo].type"
              placeholder=""
              v-model="dataForm.configuracion.predeterminados.predeterminado"
              >
            </b-form-input>
            <vue-numeric 
            v-if="datadb[inputTabla][inputCampo].datatype.type=='price'"
            separator="."   
            class="form-control" 
            :empty-value="datadb[inputTabla][inputCampo].datatype.predeterminate" 
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]+'configurar'"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]+'configurar'"
            v-model="dataForm.configuracion.predeterminados.predeterminado"
            :precision="datadb[inputTabla][inputCampo].datatype.precision" >
          </vue-numeric>   
        </b-form-group> 
        <c-multiselect  
            v-if="datadb[inputTabla][inputCampo].datatype.type=='select'"
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]+'configurar'"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]+'configurar'"
            placeholder=""
            v-model="dataForm.configuracion.predeterminados.predeterminado"
            :options="filtrarOptions()"
            :label="datadb[inputTabla][inputCampo].datatype.label"
            :allow-empty="false"
            @input="InputSelect($event,datadb[inputTabla][inputCampo].id)"
            @select="SelectSelect($event,datadb[inputTabla][inputCampo].id)"
            @remove="removeSelect($event,datadb[inputTabla][inputCampo].id)"
            @search-change="searchChangeSelect($event,datadb[inputTabla][inputCampo].id)"
            @tag="tagSelect($event,datadb[inputTabla][inputCampo].id)"
            @open="openSelect($event,datadb[inputTabla][inputCampo].id)"
            @close="closeSelect($event,datadb[inputTabla][inputCampo].id)">
            <template v-slot:afterList >
              <div class="text-center" style="border-top: 1px solid #dcdcdc">
                <button type="button" @click="agregar" class="btn btn-link btn-sm">Agregar <b-icon tabindex="1000" scale="1.4" icon="plus"></b-icon></button>
              </div>            
            </template>										 
        </c-multiselect>
        <b-form-textarea 
            v-if="datadb[inputTabla][inputCampo].datatype.type=='textarea'"
            :trim="true"
            :id="namePath+inputTabla+inputCampo+dataIndex[namePath]+'configurar'"
            :name="namePath+inputTabla+inputCampo+dataIndex[namePath]+'configurar'"
            placeholder=""
            v-model="dataForm.configuracion.predeterminados.predeterminado"
            :no-resize="false"
            :rows="7"
            @change="changeInput"
            @input="inputInput"
            @blur="blurInput"
          ></b-form-textarea>  
        <b-form-checkbox 
            v-if="user.admin.toString()==='1'"
            v-model="dataForm.configuracion.tabla_campos.autorizar" name="check-button" :value="1" :unchecked-value="0" switch>
            Para modificar este campo se requiere autorizar 
        </b-form-checkbox> 
        <b-form-checkbox 
            v-if="user.admin.toString()==='1'"
            v-model="dataForm.configuracion.tabla_campos.disabled" name="check-button" :value="1" :unchecked-value="0" switch>
            Deshabilitar este campo (Habilitado solo para el Admin)
        </b-form-checkbox> 
        <b-button style="margin-top:40px;width:100%" @click="saveForm" variant="info" >Guardar</b-button>
      </div>   
  </b-sidebar>
</div>
</template>
<script>

function referido(n)
{
  return {id: n.id, name: n.name, documento: n.documento }
}
import { mapState } from 'vuex'
import Multiselect  from '@/components/vue-multiselect/src/'
import Multiselects from 'vue-multiselect'
import { ValidationProvider } from 'vee-validate'
import '@/mixings/validate.js'
import saveMixins  from '@/mixings/save.js'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
export default 
{
  name: 'swinputs',
  components: {
    'c-multiselect': Multiselect,
    'c-multiselects': Multiselects,
    VueNumeric,
    ValidationProvider
  },
  mixins: [saveMixins],
  props: { 
    searchs: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: null
    },
    modalVariant: {
      type: String,
      default: 'primary'
    },  
    modalSize: {
      type: String,
      default: 'md'
    },  
    modalTitle: {
      type: String,
      default: 'Nuevo'
    }, 
    inputTabla: {
      type: String,
      default: false
    },
    inputCampo: {
      type: String,
      default: false
    },
    sm : {
      type: Number,
      default: 12
    },
    md : {
      type: Number,
      default: 6
    },
    lg : {
      type: Number,
      default: 3
    },
    col: {
      type: Number,
      default: 1
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: false
    },
    list: {
      type: String,
      default: ''
    },
    filter: {
      default: false
    },
    disabled: Boolean
  },
  data(){
    return {
      modalInput: {
        value: false,
        title: '',
        variant: '',
        size: ''
      },
      agregarSw: false,
      activeInput: false,      
			data: {
			  cropped: false,
			  cropping: false,
			  loaded: false,
			  name: '',
        previousUrl: '',
        index: 0,
			  type: '',
        url: '',
        url2: '',
        close1: false,
        close2: false
      },
      sidebar: '',
      checked: 0,
      predet: '',
      predetAutorizar: 0,
      predetDisabled: 0,
      disabledCampo: false
    }
  },
  async created()
  {
   if(this.datadb[this.inputTabla][this.inputCampo].datatype.type==="select" && this.datadb[this.inputTabla][this.inputCampo].datatype.agregar)
    {
      this.agregarSw=this.datadb[this.inputTabla][this.inputCampo].datatype.agregar
    }    
    if(this.modalInput.value)
    {
     this.agregarSw=false
    }
    let indexPredeterminado =  _.findIndex(this.predeterminados.configuracion.predeterminados,{'tabla': this.inputTabla,'campo': this.inputCampo, 'id_list_users': this.user.id})
    if(indexPredeterminado!==-1 && (this.dataForm[this.namePath].datos_afiliado===undefined || this.dataForm[this.namePath].datos_afiliado.id===null || this.dataForm[this.namePath].datos_afiliado.id==='' || this.dataForm[this.namePath].datos_afiliado.id===undefined))
    {
      this.predet=this.predeterminados.configuracion.predeterminados[indexPredeterminado].predeterminado
      await this.updateDataForm({state: this.inputTabla+'/'+this.inputCampo ,data: this.predeterminados.configuracion.predeterminados[indexPredeterminado].predeterminado })
    }
    else 
    {
      this.predet=this.dataForm[this.namePath][this.inputTabla][this.inputCampo]
    }
    let indexTabla_campos =  _.findIndex(this.predeterminados.configuracion.tabla_campos,{'tabla': this.inputTabla,'campo': this.inputCampo})
    if(indexTabla_campos!==-1)
    {      
      this.predetAutorizar=this.predeterminados.configuracion.tabla_campos[indexTabla_campos].auditar
      this.predetDisabled=this.predeterminados.configuracion.tabla_campos[indexTabla_campos].disabled       
      if(this.predetDisabled===1  && (this.dataForm[this.namePath].datos_afiliado.id===null || this.dataForm[this.namePath].datos_afiliado.id==='' || this.dataForm[this.namePath].datos_afiliado.id===undefined))
      {
        this.updateDataForm({state: this.inputTabla+'/'+this.inputCampo ,data: this.predeterminados.configuracion.tabla_campos[indexTabla_campos].predeterminado })
        if(this.user.admin===0)
        {
          this.disabledCampo=true
        }        
      }      
    }
    if(this.inputCampo==='consecutivo')
    {
      this.disabledCampo=true
    }
  },
  methods: { 
      async setPredeterminado()
      {
          if(this.user.admin===1)
          {
            let idTabla_campos = _.findIndex(this.predeterminados.configuracion.tabla_campos ,{'tabla': this.inputTabla,'campo': this.inputCampo})
            if(idTabla_campos!==-1)
            {
              const await0 = this.updateCrud({state:'dataForm/configuracion/tabla_campos/id', data: this.predeterminados.configuracion.tabla_campos[idTabla_campos].id})
              const await10 = this.updateCrud({state:'dataForm/configuracion/tabla_campos/autorizar', data: this.predeterminados.configuracion.tabla_campos[idTabla_campos].autorizar})
              const await11 = this.updateCrud({state:'dataForm/configuracion/tabla_campos/disabled', data: this.predeterminados.configuracion.tabla_campos[idTabla_campos].disabled})
            }
            const await3 = this.updateCrud({state:'dataForm/configuracion/tabla_campos/tabla', data: this.inputTabla})
            const await4 = this.updateCrud({state:'dataForm/configuracion/tabla_campos/campo', data: this.inputCampo})
            await await3 
            await await4

          }    

          let idPredeterminados = _.findIndex(this.predeterminados.configuracion.predeterminados,{'tabla': this.inputTabla,'campo': this.inputCampo, 'id_list_users': this.user.id})
          if(idPredeterminados!==-1)
          {
            const await0 = this.updateCrud({state:'dataForm/configuracion/predeterminados/id', data: this.predeterminados.configuracion.predeterminados[idPredeterminados].id})
            const await10 = this.updateCrud({state:'dataForm/configuracion/predeterminados/predeterminado', data: 
            this.predeterminados.configuracion.predeterminados[idPredeterminados].predeterminado})    
            
            if(this.disabledCampo===false)
            {        
              this.updateDataForm({state: this.inputTabla+'/'+this.inputCampo ,data: this.predeterminados.configuracion.predeterminados[idPredeterminados].predeterminado })
            }
          }
          else 
          {
            const await10 = this.updateCrud({state:'dataForm/configuracion/predeterminados/predeterminado', data: this.predet}) 
          }
          const await1 = this.updateCrud({state:'dataForm/configuracion/predeterminados/tabla', data: this.inputTabla})
          const await2 = this.updateCrud({state:'dataForm/configuracion/predeterminados/campo', data: this.inputCampo})
          await await1 
          await await2

          
      },
      async saveForm()
      { 
        let total=0
        let saveConfiguracion={}
        let namePath=this.namePath
        if(this.predet!==this.dataForm.configuracion.predeterminados.predeterminado)
        {
          total++         
          saveConfiguracion['predeterminados']=this.dataForm.configuracion.predeterminados  
          if(this.disabledCampo===false)
          {
            this.updateDataForm({state: this.inputTabla+'/'+this.inputCampo ,data: this.dataForm.configuracion.predeterminados.predeterminado })
          }       
          
        }
        if((this.predetAutorizar!==this.dataForm.configuracion.tabla_campos.autorizar || this.predetDisabled!==this.dataForm.configuracion.tabla_campos.disabled) && this.user.admin===1)
        {
          total++     
          this.disabledCampo=false     
          saveConfiguracion['tabla_campos']=this.dataForm.configuracion.tabla_campos
          if(this.dataForm.configuracion.tabla_campos.disabled===1)
          {            
            saveConfiguracion['tabla_campos'].predeterminado=this.dataForm.configuracion.predeterminados.predeterminado
            if(this.user.admin===0)
            {
              this.disabledCampo=true
            } 
          } 
          else 
          {
            saveConfiguracion['tabla_campos']['name']=this.datadb[this.inputTabla][this.inputCampo].label
            if(this.datadb[this.inputTabla][this.inputCampo].datatype.list!==undefined)
            {
              saveConfiguracion['tabla_campos']['list']=this.datadb[this.inputTabla][this.inputCampo].datatype.list
            }            
          }
        }
        if(total>0)
        {
          const await5 = this.updateCrud({state:'namePath', data: 'configuracion'}) 
          const await6 = this.updateDataPost({state: 'route',data: 'save_all'})
          const await7 = this.pushDataPost({state: 'data',data: saveConfiguracion})
          await await5    
          await await6 
          await await7
          await this.save(false,true)
          this.sidebar=''
          const await12 = this.resetCrud({state: 'dataForm/configuracion'})
          const await8  = this.updateCrud({state:'namePath', data: namePath})
          const await9  = this.resetGlobal({state: 'saveConfig'}) 
          await await8 
          await await9 
          await await12
        } 
        if(this.inputCampo==='consecutivo')
        {
          this.disabledCampo=true
        }
        return true        
      },
      filtrarOptionsReferido()
      {
        let list=this.lists[this.datadb[this.inputTabla][this.inputCampo].datatype.list]  
        return _.map(list,referido)
      },
      filtrarOptions()
      {
        let list=this.lists[this.datadb[this.inputTabla][this.inputCampo].datatype.list].filter(list => list.id_list_estado===undefined || list.id_list_estado.toString()==='1')
        if(typeof this.filter === 'object')
        {
          let listKeys = Object.keys(this.filter)
          return list.filter(items => { 
                let buscado = false
                for (let i = 0; i < listKeys.length; i++) {
                  if(items[listKeys[i]].toString().includes(this.filter[listKeys[i]].toString()))
                  {
                    buscado = true
                  }        
                }
                return  buscado 
            })
        }
        return list
      },
      eventBuscar(id)
      {
        this.activeInput=false
        this.$emit('buscar',id)
      },
      updateActiveInput(value)
      {
        if(value!=0)
        {
          this.activeInput=true
        }
      },
      inputInput(input)
      {
        this.$emit('input', input)
      },
      updateInput(update)
      {
        this.$emit('update', update)
      },
      blurInput()
      {
        this.$emit('blur')
      }  ,
      changeInput(change)
      {
        this.$emit('change', change)
      },
      veevalidateInputs(rules,validate,value='')
      {
        if(validate!=='') 
        {
          if(['', null, undefined].indexOf(rules) === -1)
          {
            return false
          }
          return null
        }
        return null
      },
      
      InputSelect(event,id)
      {
        this.$emit('input', {id: id, obj: event})
      },
      SelectSelect(event,id)
      {
        this.$emit('select',{id: id, obj: event})
      },
      removeSelect(event,id)
      {
        this.$emit('remove', {id: id, obj: event})
      },
      searchChangeSelect(event,id)
      {
        this.$emit('search-change', {id: id, obj: event})
      },
      tagSelect(event,id)
      {
        this.$emit('tag', {id: id, obj: event})
      },
      openSelect(event,id)
      {
        this.$emit('open', {id: id, obj: event})
      },
      closeSelect(event,id)
      {
        this.$emit('close', {id: id, obj: event})
      },
      veevalidateSelect(rules,validate,value='')
      {
        if(validate!=='')
        {
          if(['', undefined].indexOf(rules) === -1)
          {
            return false
          }
          return null
        }
        return null
      }, 
      agregar()
      {   
        this.modalInput= {
          value: true,
          variant:  this.modalVariant,
          title: this.modalTitle,
          size:  this.modalSize,
        }           
      } 
  }
}
</script>
<style>
  .form-group{
    margin: 10px 0;
  }
  .form-control {
    margin-bottom: 15px;
    width: 100% !important;
    text-transform: uppercase !important;
  }
  .form-control:focus {
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .custom-select {
    width: 100% !important;
  }
  .custom-select:focus {
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .form-control.is-valid:focus{
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .form-control.is-invalid:focus{
    -webkit-box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
  }
  .custom-file-input.is-valid:focus ~ .custom-file-label {
    -webkit-box-shadow: 0 0 0 0.4px rgba(40, 167, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(40, 167, 69, 0.25)
   }
  .custom-file-input.is-invalid:focus ~ .custom-file-label {    
    border-color: #dc3545;
    -webkit-box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25);
    box-shadow: 0 0 0 0.4px rgba(220, 53, 69, 0.25)
   }
   .form-control-readonly
   {
    background-color: #e9ecef;
    opacity: 1
   }
   .input-group .input-group-text {
     max-height: 31px;
   }
   .input-group span {   
    flex: 1 1 0%;
   }
   .input-errors {
     position: absolute;
     left: 0;
     bottom: 0;
     font-size: 12px;
     line-height: 12px;
   }
   .textarea-errors {
     position: absolute;
     left: 0;
     bottom: -18px;
     font-size: 12px;
     line-height: 12px;
   }
   .file-errors {
     position: absolute;
     left: 0;
     bottom: -21px;
     font-size: 12px;
     line-height: 12px;
   }
   .custom-file-input:focus ~ .custom-file-label {
     border-color: #80bdff;
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
   }
   .custom-file.is-invalid .custom-file-label {
     border-color: #dc3545;
   }   
  .input-date {
    width: 100%;
    border: 1px solid #cecece;
    padding: 5px 2px;
    height: 30px;
    border-radius: 3px;
    background: white;
  }
  .input-date:focus{
     border-color: #80bdff;
    -webkit-box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.4px rgba(0, 123, 255, 0.25);
  }
  .input-date.is-invalid {
     border-color: #dc3545;
   } 
  .input-date:disabled{
    background-color: #e9ecef;
    opacity: 1;
   }   
   .multiselect{
     margin-bottom: 15px;
   }
   .multiselect__single{
     overflow: hidden
   }
   .sw-inputs .input-group-text{
     background:rgba(0,80,166, 0.1) !important
   }
   .sw-list-group{
      position: absolute;
      z-index: 2;
      width: 400px;
      max-height: 255px;
      top: 35px;
      box-shadow: 1px 3px 9px rgba(0,0,0,0.1);
   }
   .sw-list-group button {
     font-size: 14px;
     padding: 10px 15px
   }
   .input-config { 
     opacity: 0;
     position: absolute;
     right: 5px;
     top: 15px;
     cursor:pointer;
   }
   .input-config:hover {    
     opacity: 1;
   }
   .input-config-inline { 
     opacity: 0;
     position: absolute;
     right: 5px;
     top: -13px;
     cursor:pointer;
   }
   .input-config-inline:hover {   
     opacity: 1;
   }
   .input-config-nolabel { 
     opacity: 0;
     position: absolute;
     right: 5px;
     top: -18px;
     cursor:pointer;
   }
   .input-config-nolabel:hover {    
     opacity: 1;
   }
   .b-sidebar{
    padding-top: 62px;
   }
   .multiselect--disabled .multiselect__tags
   {
     background: #e9ecef;
   }
       
</style>